import { SortingDirectionsType } from '~src/types';

export default function sortObjectsByField<T>(
  data: T[],
  sortField: keyof T,
  sortingDirection: SortingDirectionsType,
): T[] {
  if (!sortField) return data;

  return data.sort((a, b) => {
    const first = +a[sortField];
    const second = +b[sortField];

    if (sortingDirection === 'asc') {
      return first - second;
    }

    return second - first;
  });
}
